import React from 'react';
import TableContainer from '../../../components/Common/repotr';
import moment from 'moment';
import {useDispatch} from 'react-redux';
import {updateReconciliation} from '../../../store/Ledger/actions';

const GroupTable = (props) => {
  const dispatch = useDispatch();
  const columns = [
    {
      Header: 'Tran Id',
      Cell: (cell) => {
        const particularValues = new Set(['Journal', 'Sales - Currency', 'Sales - Metal', 'Purchase - Metal', 'Purchase - Currency']);
        const tranID = cell?.cell?.row?.original?.tranID;
        const particular = cell?.cell?.row?.original?.particular;
        return <div>{tranID === 0 || (particular && particularValues.has(particular)) ? '' : tranID}</div>;
      },
      Filter: false
    },

    {
      Header: 'Date',
      Cell: (cell) => {
        return (
          <div
            className='cursor text-primary'
            onClick={() => {
              if (
                cell?.cell?.row?.original?.particular == 'Bank Tran Journal121' ||
                cell?.cell?.row?.original?.particular == 'Bank Comm Journal'
              ) {
                return;
              } else {
                props?.handleChangeLeader(cell?.cell?.row?.original?.tranID, cell?.cell?.row?.original?.particular);
              }
            }}
          >
            {/* <div className='cursor text-primary'> */}{' '}
            {moment(cell?.cell?.row?.original.tranDate).format('DD/MM/YYYY') === '01/01/1900'
              ? ''
              : moment(cell?.cell?.row?.original.tranDate).format('DD/MM/YYYY')}
          </div>
        );
      },
      Filter: false
    },

    {
      Header: 'Particular',
      Cell: (cell) => {
        return <div>{cell?.cell?.row?.original.particular}</div>;
      },
      Filter: false
    },
    {
      Header: 'Narration',
      Cell: (cell) => {
        return <div>{cell?.cell?.row?.original.naration}</div>;
      },
      Filter: false
    },
    {
      Header: 'Brokerage',
      Cell: (cell) => {
        return <div>{cell?.cell?.row?.original.brokerage == 0 ? null : cell?.cell?.row?.original.brokerage}</div>;
      },
      Filter: false
    },
    {
      Header: 'Cr Amount',
      Cell: (cell) => {
        return <div>{cell?.cell?.row?.original.cAmount == 0 ? null : cell?.cell?.row?.original.cAmount}</div>;
      },
      Filter: false
    },

    {
      Header: 'Dr Amount',
      Cell: (cell) => {
        return <div>{cell?.cell?.row?.original.dAmount == 0 ? null : cell?.cell?.row?.original.dAmount}</div>;
      },
      Filter: false
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      Filter: true
    },
    {
      Header: 'Reconciliation',
      Cell: (cell) => {
        return (
          <div>
            {cell?.cell?.row?.original?.tranID ? (
              <>
                <input
                  className='cursor mx-2'
                  type='checkbox'
                  checked={cell?.cell?.row?.original?.reconciliation}
                  onChange={(e) => {
                    // dispatch(updateReconciliation(cell?.cell?.row?.original?.tranID, e.target.checked));
                    props?.handleReconciliation(cell?.cell?.row?.original?.tranID, e.target.checked);
                  }}
                />
                {cell?.cell?.row?.original?.reconciliation ? (
                  <span className=' badge badge-pill badge-soft-success font-size-12'>Yes</span>
                ) : (
                  <span className=' badge badge-pill badge-soft-warning font-size-12'>No</span>
                )}
              </>
            ) : null}
          </div>
        );
      },
      Filter: false
    }
  ];
  const columns2 = [
    {
      Header: 'Tran Id',
      Cell: (cell) => {
        const particularValues = new Set(['Journal', 'Sales - Currency', 'Sales - Metal', 'Purchase - Metal', 'Purchase - Currency']);
        const tranID = cell?.cell?.row?.original?.tranID;
        const particular = cell?.cell?.row?.original?.particular;
        return <div>{tranID === 0 || (particular && particularValues.has(particular)) ? '' : tranID}</div>;
      },
      Filter: false
    },
    {
      Header: 'Date',
      Cell: (cell) => {
        return (
          <div
            className='cursor text-primary'
            onClick={() => {
              if (cell?.cell?.row?.original?.particular == 'Bank Tran Journal') {
                return;
              } else {
                props?.handleChangeLeader(cell?.cell?.row?.original?.tranID, cell?.cell?.row?.original?.particular);
              }
            }}
          >
            {/* <div className='cursor text-primary'> */}{' '}
            {moment(cell?.cell?.row?.original.tranDate).format('DD/MM/YYYY') === '01/01/1900'
              ? ''
              : moment(cell?.cell?.row?.original.tranDate).format('DD/MM/YYYY')}
          </div>
        );
      },
      Filter: false
    },
    {
      Header: 'Particular',
      Cell: (cell) => {
        return <div>{cell?.cell?.row?.original.particular}</div>;
      },
      Filter: false
    },

    {
      Header: 'Brokerage',
      Cell: (cell) => {
        return <div>{cell?.cell?.row?.original.brokerage == 0 ? null : cell?.cell?.row?.original.brokerage}</div>;
      },
      Filter: false
    },
    {
      Header: 'Cr Amount',
      Cell: (cell) => {
        return <div>{cell?.cell?.row?.original.cAmount == 0 ? null : cell?.cell?.row?.original.cAmount}</div>;
      },
      Filter: false
    },
    {
      Header: 'Dr Amount',
      Cell: (cell) => {
        return <div>{cell?.cell?.row?.original.dAmount == 0 ? null : cell?.cell?.row?.original.dAmount}</div>;
      },
      Filter: false
    },
    {
      Header: 'Balance',
      accessor: 'balance',
      Filter: true
    },
    {
      Header: 'Reconciliation',
      Cell: (cell) => {
        return (
          <div>
            {cell?.cell?.row?.original?.tranID ? (
              <>
                <input
                  className='cursor mx-2'
                  type='checkbox'
                  checked={cell?.cell?.row?.original?.reconciliation}
                  onChange={(e) => {
                    // dispatch(updateReconciliation(cell?.cell?.row?.original?.tranID, e.target.checked));
                    props?.handleReconciliation(cell?.cell?.row?.original?.tranID, e.target.checked);
                  }}
                />
                {cell?.cell?.row?.original?.reconciliation ? (
                  <span className=' badge badge-pill badge-soft-success font-size-12'>Yes</span>
                ) : (
                  <span className=' badge badge-pill badge-soft-warning font-size-12'>No</span>
                )}
              </>
            ) : null}
          </div>
        );
      },
      Filter: false
    }
  ];

  return (
    <>
      <TableContainer
        columns={props.handleFilter ? columns : columns2}
        data={props?.tableData}
        isFilterIs={props.handleFilter}
        tableDataExtra={props?.tableDataExtra}
        asc={true}
        isGlobalFilter={false}
        customPageSize={20}
        isReconciliation={true}
      />
    </>
  );
};

export default GroupTable;
